import { connectAppStore } from "../../../Store/AppStore";
import PageDependencies from "../../../Feature/PageDependencies";
import SimulationLogDataTable from "./SimulationLogDataTable";

const UserSimulationLogs = (props) => {
    const { 
        Fragment,
        useEffect,
        useState,
        layoutManager,
        getData,
        useReducerSmart,
        AppLoading,
    } = PageDependencies();
    let debug = layoutManager.Layout_GetDebugModel(props);
    const [extraPostModel, setExtraPostModel] = useState({});
    const [viewModel, dispatchViewModel, bindingViewModel] = useReducerSmart();
    const [loading, setLoading] = useState({ isLoading: false, text: "" });
    const [reloadForm, setReloadForm] = useState("");
    const [data, setData] = useState([]);

      const loadUserInfo = async ()=>{
    const userRoleResponse = await getData.processPost(true, "api/DefaultModel/Accessor/Get", {});
    if(userRoleResponse !== undefined){
      if(userRoleResponse.viewModel !== undefined){
        const userId = userRoleResponse.viewModel.userId;
        dispatchViewModel({userId: userId});
        setExtraPostModel({userId: userId})
      }
    }
  }

    useEffect(()=>{
        layoutManager.Layout_HideHeadterButton_Footer_HideSideBar(props);
        loadUserInfo();
    },[]);

    return (
        <Fragment>
            {debug && <p>{JSON.stringify(viewModel)}</p>}
            {loading.isLoading && (<AppLoading active><div>{loading.text}</div></AppLoading>)}
            <div className="app-main__inner">
                <div className="app-page-title">
                    <div className="page-title-wrapper">
                        <div className="page-title-heading">
                            <div className="page-title-icon">
                                <i className="pe-7s-credit icon-gradient bg-tempting-azure">
                                </i>
                            </div>
                            <div>
                                Simulation History
                            </div>
                        </div>
                    </div>
                </div>
                <div className="main-card mb-3 card">
                    <div data-parent="#SimulationLogs" id="SimulationLogsDiv" className="collapse show">
                        <div className="card-body">
                            <SimulationLogDataTable
                                debug = {debug}
                                data = {data}
                                setData = {setData}
                                extraPostModel = {extraPostModel}
                                url="api/SimulationLogs/Accessor"
                                tableReload = {reloadForm}
                                setTableReload = {setReloadForm}
                            ></SimulationLogDataTable>
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    );
}
export default  connectAppStore(UserSimulationLogs);
